import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import EarningCategoryRebate from 'core/modules/EarningCategoryRebate/EarningCategoryRebate';

import './MerchantEarningCategories.scss';

function MerchantEarningCategories({ tiers, config }) {
  const { rebateOptions } = config;

  if (isEmpty(tiers)) {
    return null;
  }

  return (
    <div className="mn_earningCategories">
      <h3>Earning by category</h3>
      <ul>
        {tiers.map(tier => (
          <li key={tier.name}>
            <span className="mn_categoryName">{tier.name}</span>
            {tier.rebate && (
              <EarningCategoryRebate {...tier.rebate} {...rebateOptions} />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

MerchantEarningCategories.propTypes = {
  tiers: PropTypes.arrayOf(PropTypes.shape({})),
  config: PropTypes.shape({}),
};

MerchantEarningCategories.defaultProps = {
  config: {},
  tiers: [],
};

export default (props) =>
  <ComponentErrorBoundary><MerchantEarningCategories {...props} /></ComponentErrorBoundary>;
